module.exports = __webpack_public_path__ + "img/nature_zitrone_2_new-mob.4c4cf4b0.png";